import angular from 'angular';
import { InfoCardComponent } from './info-card.component';
export var InfoCardModule = angular
    .module('InfoCardModule', [])
    .component('infoCard', InfoCardComponent)
    .name;
//# sourceMappingURL=info-card.module.js.map